export default {"src":"/_next/static/media/app-store-badge.a3a8a50c.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};